var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"example"},[_c('van-uploader',{attrs:{"readonly":"","show-upload":false,"deletable":false,"preview-size":69},model:{value:(_vm.exampleImg),callback:function ($$v) {_vm.exampleImg=$$v},expression:"exampleImg"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }